// src/hooks/useSubscription.js
// FINAL VERSION: Connected to Global AuthContext

import { useEffect, useState } from 'react';
import { Purchases } from '@revenuecat/purchases-capacitor';
import { useAuth } from '../context/AuthContext'; // ⚡ Import the Global Brain

const REVENUECAT_API_KEY = "appl_hSKbqCBlSgaNGjXoYyIqGPOommJ";

export const useSubscription = () => {
  // 1. DELETE LOCAL STATE. USE GLOBAL TRUTH.
  // We pull 'isPremium' directly from AuthContext. 
  // If Pricing or Dashboard says "Active", this will also say "True" instantly.
  const { isPremium, triggerManualCheck } = useAuth();
  
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadOfferings = async () => {
      try {
        // We configure here just to be safe, but AuthContext likely handled it.
        await Purchases.configure({ apiKey: REVENUECAT_API_KEY });

        // Load Products
        const offerings = await Purchases.getOfferings();
        if (offerings.current && offerings.current.availablePackages.length !== 0) {
          setPackages(offerings.current.availablePackages);
        }
      } catch (error) {
        console.error("RevenueCat Offerings Error:", error);
      } finally {
        setLoading(false);
      }
    };

    loadOfferings();
  }, []);

  // Function to buy a package
  const buyPackage = async (packageToBuy) => {
    try {
      const { customerInfo } = await Purchases.purchasePackage({ aPackage: packageToBuy });
      
      // ⚡ CRITICAL: Tell AuthContext to update the entire app
      if (triggerManualCheck) {
          await triggerManualCheck();
      }
      
      return true;
    } catch (error) {
      if (!error.userCancelled) {
        console.error("Purchase Error:", error);
      }
      return false;
    }
  };

  // Function to restore purchases
  const restorePurchases = async () => {
    try {
      const { customerInfo } = await Purchases.restorePurchases();
      
      // ⚡ CRITICAL: Tell AuthContext to update the entire app
      if (triggerManualCheck) {
          await triggerManualCheck();
      }
      return true;
    } catch (error) {
      console.error("Restore Error:", error);
      return false;
    }
  };

  return { 
      isPremium, // <--- This now comes from the Global Brain
      packages, 
      buyPackage, 
      restorePurchases, 
      loading 
  };
};